<template>
  <div id="dashboard-equipes">
    <div class="row">
      <div class="col-lg-12">
        <h2>
          <strong>Equipes</strong> por classificação considerando o parâmetro de
          cadastro
        </h2>
        <hr />
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-4">
        <donut-chart :series="dadosDashboard" nivel="2"></donut-chart>
      </div>
      <div class="col-lg-8">
        <tree-map
          nivel="2"
          :series="dadosDashboard"
          @openModal="openModal($event)"
        ></tree-map>
      </div>
      <b-modal
        id="dashboard-equipes-modal"
        v-model="modal.enabled"
        centered
        size="xl"
        hide-footer
      >
        <template #modal-title>
          {{ modal.title }}
          <span class="tag-indicador"> CVAT </span>
          <span v-if="periodo != null" class="tag-indicador">
            {{ periodo.label }}
          </span>
        </template>

        <div
          v-if="exibirFiltroPrevistoRealizado"
          class="d-flex justify-content-end align-items-center modal-filtros"
        >
          <ResultadoToggle v-model="tipoResultado" :disabledMensal="true" />

          <FiltroPrevistoRealizado v-model="filtroResultadoQuadrimestral" />
        </div>

        <v-app class="app-tabela">
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar por CNES, UBS, Equipe ou INE"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="modal.table.loading"
                loading-text="Carregando, Por favor espere"
                :headers="headers"
                :items="indexedItems"
                :item-class="getRowColor"
                :search="search"
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="index"
                show-expand
                class="elevation-1"
                @item-expanded="onItemExpanded"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec">
                    <FonteSincronizadorC />
                  </div>
                  <span class="paginacao"
                    >{{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} equipes</span
                  >
                </template>

                <template v-slot:item.vinculo_acompanhamento="{ item }">
                  <DashboardEquipesProgressBar
                    :items="item.dados_vinculo_acompanhamento"
                    :total-label="item.total_vinculo_acompanhamento"
                  />
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td colspan="6">
                    <div class="row">
                      <div class="col-lg-6">
                        <cidadaos-vinculados-chart
                          :series="expandedItem.vinculados.series"
                          nivel="2"
                        ></cidadaos-vinculados-chart>
                      </div>
                      <div class="col-lg-6">
                        <cidadaos-acompanhados-chart
                          :series="expandedItem.acompanhados.series"
                          nivel="2"
                        ></cidadaos-acompanhados-chart>
                      </div>
                    </div>
                  </td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear
                    color="blue"
                    :height="10"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
                <template v-slot:no-results style="padding: 0px">
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-app>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DonutChart from './DonutChart.vue'
import TreeMap from './TreeMap.vue'
import CidadaosVinculadosChart from './CidadaosVinculadosChart.vue'
import CidadaosAcompanhadosChart from './CidadaosAcompanhadosChart.vue'
import FiltroPrevistoRealizado from './FiltroPrevistoRealizado.vue'
import utils from '@/mixins/utils.js'
import DashboardEquipesProgressBar from './DashboardEquipesProgressBar.vue'
import ResultadoToggle from './ResultadoToggle.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    DonutChart,
    TreeMap,
    CidadaosVinculadosChart,
    CidadaosAcompanhadosChart,
    FiltroPrevistoRealizado,
    DashboardEquipesProgressBar,
    ResultadoToggle,
  },
  props: {
    dadosDashboard: {
      type: Array,
      default: () => {},
    },
    dadosEscore: {
      type: Array,
      default: () => {},
    },
    periodo: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'ine',
        },
        {
          text: 'Vínculo e Acompanhamento',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'vinculo_acompanhamento',
          width: '350px',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      expanded: [],
      modal: {
        title: '',
        enabled: false,
        dadosMs: '[]',
        table: {
          loading: false,
          data: [],
        },
      },
      expandedItem: {
        vinculados: {
          series: [],
        },
        acompanhados: {
          series: [],
        },
      },
      tipoResultado: 'quadrimestral',
      filtroResultadoQuadrimestral: 'previsto',
      dadosModalOriginais: [],
    }
  },
  watch: {
    filtroResultadoQuadrimestral() {
      this.aplicarFiltroPrevistoRealizado()
    },
  },
  computed: {
    indexedItems() {
      return this.modal.table.data.map((item, index) => {
        return {
          index: index,
          ...item,
        }
      })
    },

    exibirFiltroPrevistoRealizado() {
      if (!this.periodo) {
        return false
      }

      const mes = Number(this.periodo.value.split('/')[0])

      return [4, 8, 12].includes(mes)
    },

    isRealizadoSelecionado() {
      return (
        this.exibirFiltroPrevistoRealizado &&
        this.filtroResultadoQuadrimestral === 'realizado'
      )
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    onItemExpanded(item) {
      this.expandedItem.vinculados.series = [
        {
          data: [
            item.item.cad_param * 1.5,
            item.item.cad_param,
            item.item.cad_pec,
            item.item.qtd_cad0_75,
            item.item.qtd_cad1_5,
          ],
        },
      ]
      this.expandedItem.acompanhados.series = [
        {
          data: [
            Math.abs(item.item.cad_pec - item.item.qtd_cad_acomp),
            item.item.qtd_acomp1_0,
            item.item.qtd_acomp1_2,
            item.item.qtd_acomp1_3,
            item.item.qtd_acomp2_5,
          ],
        },
      ]
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {},

    /**
     * Abre o modal de equipes da classificação selecionada.
     *
     * Mantém a lógica atual dos dados previstos e armazena os dados
     * realizados apenas para exibição na coluna Vínculo e Acompanhamento.
     *
     * @param {Object} item Dados da classificação selecionada.
     * @returns {void}
     */
    openModal(item) {
      this.currentPage = 1
      this.expanded = []
      this.search = ''
      this.filtroResultadoQuadrimestral = 'previsto'
      this.modal.enabled = true
      this.modal.title = item.x

      const dadosTabela = this.dadosDashboard.find((el) => {
        return el.classificacao == item.x
      })

      if (dadosTabela != undefined) {
        this.modal.dadosMs = dadosTabela.dados_ms || '[]'
        this.dadosModalOriginais = JSON.parse(dadosTabela.equipes || '[]')
        this.aplicarFiltroPrevistoRealizado()
      }
    },

    /**
     * Busca os dados realizados da equipe pelo INE.
     *
     * @param {Object} equipe Dados previstos da equipe.
     * @returns {Object|null}
     */
    getRealizadoEquipe(equipe) {
      if (!equipe?.ine) {
        return null
      }

      const dadosMsLista = this.parseObjectJson(this.modal.dadosMs || '[]')

      return dadosMsLista.find((item) => item?.ine === equipe.ine) || null
    },

    /**
     * Busca o indicador realizado correspondente.
     *
     * @param {Object} item Dados da equipe.
     * @param {Number|String} indicador Código do indicador.
     * @returns {Object|null}
     */
    getIndicadorRealizado(item, indicador) {
      if (!item.dadosMs || !Array.isArray(item.dadosMs.all_indicadores)) {
        return null
      }

      return (
        item.dadosMs.all_indicadores.find(
          (el) => Number(el.indicador) === Number(indicador)
        ) || null
      )
    },

    /**
     * Retorna o resultado realizado de um indicador.
     *
     * @param {Object} item Dados da equipe.
     * @param {Number|String} indicador Código do indicador.
     * @returns {*}
     */
    getResultadoIndicadorRealizado(item, indicador) {
      const realizado = this.getIndicadorRealizado(item, indicador)

      return realizado?.resultado ?? '-'
    },

    /**
     * Monta os dados da coluna Vínculo e Acompanhamento.
     *
     * No previsto, mantém a exibição atual.
     * No realizado, mantém o valor da barra com o previsto e altera
     * somente o texto exibido para previsto / realizado.
     *
     * @param {Object} equipe Dados da equipe.
     * @returns {Array}
     */
    getDadosVinculoAcompanhamento(equipe) {
      const vinculoPrevisto = Number(equipe.escore_param_cad || 0)
      const acompanhamentoPrevisto = Number(equipe.escore_param_acomp || 0)

      if (!this.isRealizadoSelecionado) {
        return [
          { value: vinculoPrevisto, label: vinculoPrevisto },
          { value: acompanhamentoPrevisto, label: acompanhamentoPrevisto },
        ]
      }

      return [
        {
          value: vinculoPrevisto,
          label: `${vinculoPrevisto} / ${this.getResultadoIndicadorRealizado(
            equipe,
            54
          )}`,
        },
        {
          value: acompanhamentoPrevisto,
          label: `${acompanhamentoPrevisto} / ${this.getResultadoIndicadorRealizado(
            equipe,
            55
          )}`,
        },
      ]
    },

    /**
     * Retorna o texto do total da coluna Vínculo e Acompanhamento.
     *
     * No previsto, retorna null para o componente calcular a soma normalmente.
     * No realizado, retorna o texto previsto / realizado usando o resultado
     * total importado em dados_ms.
     *
     * @param {Object} equipe Dados da equipe.
     * @returns {String|null}
     */
    getTotalVinculoAcompanhamento(equipe) {
      if (!this.isRealizadoSelecionado) {
        return null
      }

      const previsto =
        Number(equipe.escore_param_cad || 0) +
        Number(equipe.escore_param_acomp || 0)

      return `${previsto} / ${equipe.dadosMs?.resultado ?? '-'}`
    },

    /**
     * Atualiza os dados da tabela conforme o filtro Previsto/Realizado.
     *
     * A lógica dos gráficos é preservada, pois os campos originais da equipe
     * continuam iguais. Apenas a coluna Vínculo e Acompanhamento recebe
     * o texto previsto / realizado.
     *
     * @returns {void}
     */
    aplicarFiltroPrevistoRealizado() {
      this.modal.table.data = this.dadosModalOriginais.map((equipe) => {
        const item = {
          ...equipe,
          dadosMs: this.getRealizadoEquipe(equipe),
        }

        return {
          ...item,
          dados_vinculo_acompanhamento:
            this.getDadosVinculoAcompanhamento(item),
          total_vinculo_acompanhamento:
            this.getTotalVinculoAcompanhamento(item),
        }
      })
    },
  },
}
</script>

<style lang="scss">
#dashboard-equipes {
  margin: 30px 0;
  h2 {
    font-size: 22px;
  }
}
</style>

<style>
#dashboard-equipes-modal .modal-filtros {
  gap: 10px;
  margin-bottom: 15px;
}

#dashboard-equipes-modal .resultado-toggle {
  margin-bottom: 0;
}

#dashboard-equipes-modal .tag-indicador {
  background: #d6d2d2;
  color: #000;
  padding: 5px 10px;
  border-radius: 32px;
  font-size: 13px;
  margin-left: 5px;
  font-weight: 700;
}
</style>
